// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/custom/common.scss'
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// 整屏滚动
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import './assets/font/font.css';
// swiper轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'babel-polyfill';
import promise from 'es6-promise';
import {
  set
} from 'shelljs'
promise.polyfill();
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'

// Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(Viewer);
Vue.use(VueFullPage);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
// Vue.use(CryptoJS)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
// Viewer.setDefaults({
//   Options: {
//     "inline": true,
//     "button": true,
//     "navbar": true,
//     "title": true,
//     "toolbar": true,
//     "tooltip": true,
//     "movable": true,
//     "zoomable": true,
//     "rotatable": true,
//     "scalable": true,
//     "transition": true,
//     "fullscreen": true,
//     "keyboard": true,
//     "url": "data-source"
//   }
// })

// 页面变化时，回到页面顶部
router.afterEach((to, from, next) => {
  // setTimeout(() => {
  //     next()
  // }, 5000);
  // console.log(to.meta)
  if (to.meta.title) {
    document.title = to.meta.title; //在路由里面写入的meta里面的title字段
  }
  window.scrollTo(0, 0);
});
// 判断访问设备跳转相应网站
// var browser = {
//   versions: function () {
//     var u = navigator.userAgent,
//       app = navigator.appVersion;
//       console.log(u)
//     return { //移动终端浏览器版本信息   
//       trident: u.indexOf('Trident') > -1, //IE内核  
//       presto: u.indexOf('Presto') > -1, //opera内核  
//       webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核  
//       gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核  
//       mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端  
//       ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端  
//       android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器  
//       iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器  
//       iPad: u.indexOf('iPad') > -1, //是否iPad    
//       webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部  
//       weixin: u.indexOf('MicroMessenger') > -1, //是否微信   
//       qq: u.match(/\sQQ/i) == " qq" //是否QQ  
//     };
//   }(),
//   language: (navigator.browserLanguage || navigator.language).toLowerCase()
// }

// if (browser.versions.mobile || browser.versions.ios || browser.versions.android ||
//   browser.versions.iPhone || browser.versions.iPad) {
//     // wap端
//   // window.location = "http://pwa.f9499.top";
//   // window.location ='http://192.168.3.58:8080/'
// }else{
//   // pc端
//   // window.location = "http://school.jydltech.com";
// }



// WEBPACK FOOTER //
// ./src/main.js